import React, {useRef, useState} from 'react';

import {colors} from 'js-libs/sweetcommons/styles';
import {Tooltip} from 'reactstrap';
import styled from 'styled-components';

import {
  FullHTMLLink,
  FullHTMLLinkToType,
} from 'app/components/general/FullHTMLLink';
import {cannotHoverAndCanTouch} from 'app/utils/browser';

const StyledLink = styled(FullHTMLLink)`
  position: relative;
`;

const StyledBadgeSpan = styled.span`
  background: ${colors.lightGray};
  padding: 0 0.28rem;
  border-radius: 100%;

  position: absolute;
  right: 5px;
  top: 5px;
  font-size: 65%;
  font-weight: normal;
  min-width: 15px;

  .active & {
    color: ${colors.linkBlue};
  }
`;

export type Props = {
  title?: string | JSX.Element;
  icon: string;
  link?: FullHTMLLinkToType;
  active?: boolean;
  badge?: React.ReactNode;
  forceTooltipShow?: boolean;
  disabled?: boolean;
  disabledTooltipText?: React.ReactNode;
  onClick?: (ev: React.SyntheticEvent<any>) => void;
};

export const SidebarItem = ({
  title,
  icon,
  link,
  onClick,
  active,
  badge,
  disabledTooltipText,
  forceTooltipShow,
  disabled = false,
}: Props) => {
  const [tooltipVisible, setTooltipVisible] = useState(false);

  const notDisabledProps = {
    replace: true,
    renderRegularLink: disabled,
    activeClassName: 'active',
    onlyActiveOnIndex: true,
    to: link,
  };

  const show = () => {
    if (!cannotHoverAndCanTouch) {
      setTooltipVisible(true);
    }
  };
  const hide = () => {
    setTooltipVisible(false);
  };
  const onClickWrapper = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (disabled) {
      e.preventDefault();
    } else if (onClick != null) {
      onClick(e);
    }
  };

  const spanRef = useRef<HTMLInputElement | null>(null);

  const tooltipText =
    disabled && disabledTooltipText != null ? disabledTooltipText : title;
  return (
    <span ref={spanRef} onMouseOver={show} onMouseOut={hide}>
      <StyledLink
        className={`list-group-item ${active === true ? 'active' : ''} ${
          disabled ? 'disabled' : ''
        }`}
        onClick={onClickWrapper}
        {...(disabled ? Object.freeze({}) : notDisabledProps)}
      >
        <i className={`${icon}`} />
        {badge !== undefined ? (
          <StyledBadgeSpan>{badge}</StyledBadgeSpan>
        ) : null}
      </StyledLink>
      {spanRef && title !== undefined ? (
        <Tooltip
          id={`sidebar-item-${icon}`}
          placement="right"
          target={spanRef}
          isOpen={tooltipVisible || forceTooltipShow}
          modifiers={{
            preventOverflow: {
              escapeWithReference: true,
            },
          }}
        >
          <span className="text-capitalize">{tooltipText}</span>
        </Tooltip>
      ) : null}
    </span>
  );
};
